import(/* webpackMode: "eager" */ "C:\\Gurinder\\Projects\\REACT PROJECTS\\performance_web\\src\\app\\error.tsx");
